<div class="toast-message" [class.waiting]="actionExecuted">
  @if (icon) {
    <mat-icon class="toast-icon" [svgIcon]="icon" />
  }

  <div class="toast-text">
    {{ message }}
    @if (countdown()) {
      ({{ counter() }})
    }
  </div>

  @for (currentAction of actions; track currentAction.text) {
    <button type="button" class="toast-action-button" (click)="action(currentAction, $event)">
      {{ currentAction.text }}
    </button>
  }
  @if (!persistent()) {
    <button type="button" class="toast-close-icon" aria-label="Close" (click)="remove()">
      <mat-icon svgIcon="close" />
    </button>
  }
</div>
